import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { FaArrowUp } from 'react-icons/fa';
import './Footer.css'
import SubShare from '../../SubShare';

const Footer = () => {
    const { t } = useTranslation(); 
    const [showScrollTop, setShowScrollTop] = useState(false);

    // Show or hide the scroll-to-top button based on scroll position
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Scroll to the top function
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    const getCurrentYear = () => new Date().getFullYear();

    return (
        <footer className="custom-footer">
            <div className="custom-footer-container">
            <div className="custom-footer-logo">
                    <a href="/" className="custom-footer-logo-text">PlusLife</a>
                </div>
                <div className="custom-footer-sections">
                    <div className="custom-footer-links">
                        <h4>{t("footer.quick_links")}</h4>
                       
                        <ul className="custom-footer-link-list">
                            {/* <Link to="/careers">Join Us</Link> */}
                            <Link to="/about">{t("footer.about_us")}</Link>
                            <Link to="/clinic-pricing">{t("footer.pricing")}</Link>
                            <Link to="/contact">{t("footer.contact_us")}</Link>
                            {/* <Link to="/services">Our Services</Link> */}
                            {/* <Link to="/privacy">{t("footer.privacy")}</Link> */}
                            <Link to="/terms">{t("footer.terms")}</Link>
                        </ul>
                    </div>
                    <div className="custom-footer-social">
                        <h4>{t("footer.follow")}</h4>
                        <div className="custom-footer-social-links">
                           <SubShare />
                        </div>
                        <div className="social-overlay"></div> 
                    </div>
                    <div className="custom-footer-contact">

                        {/* <p>105 Owlridge Drive, Brampton, Ontario L6X 0M7, Canada</p> */}
                       
                        <h4>{t("footer.contact")}</h4>
                        {/* <p>{t("footer.location")}</p> */}
                        <p>{t("footer.contact_email")}</p>
                        <p>{t("footer.contact_phone")}</p>
                    </div>

                </div>
                <div className="custom-footer-professional-line">
                    <p style={{color:'var(--clr-grey-9)'}}>{t("footer.tagline")}</p>
                </div>
            </div>
            <div className="custom-footer-bottom">
                <p style={{color:'var(--clr-grey-9)'}}>&copy; {getCurrentYear()} {t("footer.copyright_company")} {t("footer.copyright")}</p>

            </div>

            {/* Scroll-to-top button */}
            {showScrollTop && (
                <button className="scroll-to-top" onClick={scrollToTop} aria-label="Scroll to top">
                    <FaArrowUp />
                </button>
            )}
        </footer>
    );
};

export default Footer;
